import React, { createContext, useState } from "react";

export const MerchantContext = createContext();

const MerchantProvider = ({ children }) => {
    const [merchantData, setMerchantData] = useState([]);

    return (
        <MerchantContext.Provider value={{ merchantData, setMerchantData }}>
            {children}
        </MerchantContext.Provider>
    );
};

export default MerchantProvider;
